import { useMemo } from 'react'
import { getChartBuilder } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/chartRegistry'

export const useChartOptions = (chartMode, chartProps) => {
  return useMemo(() => {
    const builder = getChartBuilder(chartMode)

    if (!builder) return null

    return builder(chartProps)
  }, [chartMode, chartProps])
}
